import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TAppSliceState = {
  isFilterOpen: boolean;
  hasSelectedFilterItem: boolean;
  currentNotificationUrl: string;
  userToken: string | null;
};

const initialState: TAppSliceState = {
  isFilterOpen: false,
  hasSelectedFilterItem: false,
  currentNotificationUrl: '',
  userToken: localStorage.getItem('token') || null,
};

const appSlice = createSlice({
  name: 'appSlice',
  initialState,
  reducers: {
    toggleFilterModal(state) {
      state.isFilterOpen = !state.isFilterOpen;
    },
    toggleHasSelectedFilterItem(
      state,
      action: PayloadAction<{ hasSelectedFilter: boolean }>,
    ) {
      state.hasSelectedFilterItem = action.payload.hasSelectedFilter;
    },
    setCurrentNotificationUrl(state, action: PayloadAction<string>) {
      state.currentNotificationUrl = action.payload;
    },
    setUserToken(state, action: PayloadAction<string>) {
      state.userToken = action.payload;
      localStorage.setItem('token', action.payload);
    },
    deleteUserToken(state) {
      state.userToken = null;
      localStorage.removeItem('token');
    },
  },
});

export default appSlice;
